<template>
    <div>
    <div :style="{height: tableHeight+'px'}">
        <template v-if="data.funtype=='drls'">
            <el-steps  :class="['stepsBox',baseerp+'Box']" :active="activeId" finish-status="success" align-center  process-status="finish">
                <el-step :description="$t('billOfExchange_upload_transaction_records')"  ></el-step>
                <el-step :description="$t('billOfExchange_process_data')" ></el-step>
                <el-step :description="$t('billOfExchange_complete')" ></el-step>
            </el-steps>
        </template>
        <template  v-if="data.funtype=='clzk'">
            <el-steps   :class="['stepsBox',baseerp+'Box']" :active="activeId" finish-status="success" align-center  process-status="finish">
                <el-step :description="$t('billOfExchange_process_data')" ></el-step>
                <el-step :description="$t('billOfExchange_complete')" ></el-step>
            </el-steps>

        </template>
        <div class="formBox"  v-if="data.funtype=='drls'">
            <div class="flex jcsb p15-10">
                <div  class="flex a-i-c">
                    <div class="labelBox">{{$t('billOfExchange_filename')}}</div>
                    <div  class="keyBox colortheme">
                        <div>{{fileData.fileName}}</div>
                        <div style="color: red" v-if="errorMessage">{{errorMessage}}</div>
                    </div>
                </div>
                <div style="position: relative;display: inline-block">
                    <input type="file" name="files" value="" id="uploadfile1"
                           ref="uploadclear"    class="upload-input uploadfile1" @change="uploadFile"  >
                    <el-button type="text" v-if="activeId==0">[{{$t('billOfExchange_modify')}}]</el-button>
                </div>
            </div>
            <template v-if="activeId==0">
                <div class="flex a-i-c p15-10">
                <div class="labelBox">{{$t('form_company')}}</div>
                <div class="keyBox">{{fileData.vc_gsname}}</div>
            </div>
            <div class="flex a-i-c p15-10">
                <div class="labelBox">{{$t('billOfExchange_bank_of_deposit')}}</div>
                <div class="keyBox">{{fileData.vc_bankname}}</div>
            </div>
            <div class="flex a-i-c p15-10">
                <div class="labelBox">{{$t('billOfExchange_account')}}</div>
                <div class="keyBox">{{fileData.vc_bank_account}}</div>
            </div>
            <div class="flex a-i-c p15-10">
                <div class="labelBox">{{$t('form_currency')}}</div>
                <div class="keyBox">{{fileData.vc_bzname}}</div>
            </div>
            <div class="flex a-i-c p15-10">
                <div class="labelBox">{{$t('form_exchange_rate')}}</div>
                <el-input-number class="keyBox inputH"  v-model="fileData.f_rate" :min="0" :controls="false"></el-input-number>
<!--                <div>{{fileData.fileName}}</div>-->
            </div>
            <div class="flex a-i-c p15-10">
                <div class="labelBox">{{$t('billOfExchange_type')}}</div>
                <div class="keyBox">{{fileData.vc_type}}</div>
            </div>
            </template>

        </div>
        <div v-if="sc&&data.funtype=='drls'" class="">
            <div class="flex p15-10">
                <div class="labelBox">{{$t('billOfExchange_upload_results')}}</div>
                <div class="keyBox">
                    <div  :class="[baseerp+'Box']">
                        <el-progress  :percentage="scpercentage"></el-progress>

                    </div>
                    <div v-if="scpercentage==100">
                        <span>{{importFileData.message}}</span>
                    </div>
                </div>

            </div>
            <div class="flex a-i-b p15-10" v-if="importFileData.errorFileName">
                <div class="labelBox">{{$t('billOfExchange_failed_attachment')}}</div>
                <div class="keyBox">
                    <div>
                        <a class="filecss" :download="importFileData.errorFileName" mce_href="#"
                           :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+importFileData.errorFileNewName+',bankflow\'}','utf-8')">
                            {{importFileData.errorFileName}}
                        </a>
                    </div>
                </div>
            </div>

            <div class="flex a-i-b p15-10" v-if="importFileData.sourceFileName">
                <div class="labelBox">{{$t('billOfExchange_original_attachment')}}</div>
                <div class="keyBox">
                    <div>
                        <a class="filecss" :download="importFileData.sourceFileName" mce_href="#"
                           :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+importFileData.sourceFileNewName+',bankflow\'}','utf-8')">
                            {{importFileData.sourceFileName}}
                        </a>
                    </div>
                </div>

            </div>
            <div class="scListBox " >
                <div class="bor flex jcsb a-i-c"><span>{{$t('billOfExchange_upload_failure_log')+':'+scList.length+$t('billOfExchange_records')}}</span>
                <el-button type="text" size="mini" @click="scShowChange">{{scShow?$t('billOfExchange_click_to_collapse'):$t('billOfExchange_click_to_expand')}}</el-button></div>
                <div :style="{height: (tableHeight-450)/2+'px'}" class="bor p-8-10 o-f-y-s" v-show="scShow"  >
                    <div v-for="(item,index) in scList" class="txtBox">
                        <span :class="[baseerp+'color',baseerp+'yuancolor','yuan']">{{index+1}}</span><span>{{item}}</span>
                    </div>
                </div>
            </div>
        </div>
<!--        <div v-if="hp"  class="">-->
<!--            <div class="flex a-i-c p15-10">-->
<!--                <div class="labelBox">处理汇票</div>-->
<!--                <div class="keyBox">-->
<!--                    <div  :class="[baseerp+'Box']">-->
<!--                        <el-progress :percentage="hppercentage"></el-progress>-->

<!--                    </div>-->
<!--                    <div v-if="hppercentage==100">-->
<!--                        <span>{{hppercentageTxt}}</span>-->

<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->
<!--            <div class="scListBox ">-->
<!--                <div class="bor flex jcsb a-i-c"><span>{{'处理汇票失败记录:'+hpList.length+'条'}}</span><el-button type="text"  size="mini"  @click="hpShowChange">{{hpShow?$t('billOfExchange_click_to_collapse'):$t('billOfExchange_click_to_expand')}}</el-button></div>-->
<!--                <div  :style="{height: tableHeight+'px'}" class="bor p-8-10 o-f-y-s" v-show="hpShow">-->
<!--                    <div v-for="(item,index) in hpList">-->
<!--                        <span :class="[baseerp+'color',baseerp+'yuancolor','yuan']">{{index+1}}</span><span>{{item}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div v-if="zk"  class="">
            <div class="flex  p15-10">
                <div class="labelBox">{{$t('billOfExchange_process_data')}}</div>
                <div class="keyBox">
                    <div  :class="[baseerp+'Box']">
                        <el-progress :percentage="zkpercentage"></el-progress>

                    </div>
                    <div v-if="zkpercentage==100">
                    <div><span>{{$t('billOfExchange_accounting')}}:</span><span>{{zkpercentageTxt}}</span></div>
<!--                        <div><span>汇票:</span><span>{{hppercentageTxt}}</span></div>-->
<!--                        <div><span>核销:</span><span>{{hxpercentageTxt}}</span></div>-->
<!--                        <div><span>{{$t('billOfExchange_accounting')}}:</span><span>{{zkpercentageTxt}}</span></div>-->

                    </div>
                </div>

            </div>
            <div class="scListBox ">
                <div class="bor flex jcsb a-i-c"><span>{{$t('billOfExchange_failed_data_processing_records')+':'+zkList.length+$t('billOfExchange_records')}}</span><el-button type="text"  size="mini"  @click="zkShowChange">{{zkShow?$t('billOfExchange_click_to_collapse'):$t('billOfExchange_click_to_expand')}}</el-button></div>
                <div  :style="{height: (tableHeight-450)/2+'px'}" class="bor p-8-10 o-f-y-s" v-show="zkShow">
                    <div v-for="(item,index) in zkList">
                        <span :class="[baseerp+'color',baseerp+'yuancolor','yuan']">{{index+1}}</span><span>{{item}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="center" style="position: absolute;bottom: 15px;width: 100%">
            <el-button type="primary" :class="baseerp+'btn-bgW-borL'" size="mini" @click="close">{{$t('button_close')}}</el-button>
            <template v-if="data.funtype=='drls'">
                <el-button type="primary" :disabled="disabled" size="mini" v-if="activeId==0" @click="qrsc">{{$t('billOfExchange_confirm_upload')}}</el-button>
                <el-button type="primary" :disabled="disabled" size="mini" v-if="activeId==1" @click="clzk">{{$t('billOfExchange_process_data')}}</el-button>
            </template>

        </div>

    </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseVersion,file_url,baseApp,sse_url} from "@/utils/baseUrl";

    export default {
        name: "DaoRu",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                baseerp:'',
                file_url:'',
                baseApp:'',
                baseVersion:'',
                token:"",
                i_uid:'',
                tableHeight:0,
                activeId:0,
                scpercentage:0,
                zkpercentage:0,
                hppercentage:0,
                hppercentageTxt:'',
                zkpercentageTxt:'',
                hxpercentageTxt:'',
                scList:[],
                zkList:[],
                hpList:[],
                scShow:false,
                zkShow:false,
                hpShow:false,
                sc:false,
                zk:false,
                hp:false,
                fileData:{},
                timestamp:null,
                importFileData:{
                    message:'',
                },
                errorMessage:'',
                disabled:false,
                funtype:'',
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    // console.log(this.data,'this.data')
                    this.fileData=this.data
                    this.funtype=this.data.funtype
                    if(this.fileData.i_bzid==1)this.fileData.f_rate=1

                },
                deep:true,
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.fileData=this.data
            this.funtype=this.data.funtype
            this.baseerp=baseerp
            this.baseVersion = baseVersion;
            this.baseApp = baseApp;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            this.$nextTick(()=>{
                this.onResize();
            })
            if(this.fileData.i_bzid==1)this.fileData.f_rate=1
            if(this.data.funtype=='clzk'){
                this.clzk()
            }
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight=n.h

            },
            scShowChange(val){
                this.scShow=!this.scShow
                this.$forceUpdate()
            },
            zkShowChange(val){
                this.zkShow=!this.zkShow
                this.$forceUpdate()
            },
            hpShowChange(val){
                this.hpShow=!this.hpShow
                this.$forceUpdate()
            },
            qrsc(){
                // console.log(this.fileData.f_rate,'(this.fileData.f_rate')
                // console.log(this.fileData.i_bzid,'(this.fileData.i_bzid')
                //if (this.fileData.i_bzid!=1&&(this.fileData.f_rate!=''||this.fileData.f_rate!=undefined)){
                if (this.fileData.i_bzid!=1&&(this.fileData.f_rate==''||this.fileData.f_rate==undefined)){
                    this.$message.error(this.$t('billOfExchange_the_foreign_exchange_rate_cannot_be_left_blank'))
                }else{
                    // if(this.fileData.i_bzid==1)this.fileData.f_rate=1
                    this.importFile()
                    this.disabled=true

                }
            },
            close(){
                this.$emit('close',this.back)
                this.errorMessage=''

            },
            clhp(){
                this.scShow=false
                this.zkShow=false
                this.hpShow=true
                this.hp=true
                this.disabled=true
                this.timestamp = (new Date()).valueOf();
                this.processData('clhp')
                this.sse_funProgress('clhp')
            },
            clzk(){
                this.scShow=false
                this.hpShow=false
                this.zkShow=true
                this.disabled=true
                this.zk=true
                this.timestamp = (new Date()).valueOf();
                this.processData()
                this.sse_funProgress('clzk')
            },
            async processData(type) {
                this.back='save'
                    var param = {
                        sessionId:this.timestamp,
                        i_gsid:this.fileData.i_gsid,
                        fileRecordId:this.data.funtype=='clzk'?-1:this.importFileData.data.fileRecordId,
                        i_sktype:this.fileData.i_type,
                        f_rate:this.fileData.f_rate,
                        i_bzid:this.fileData.i_bzid,
                        // c_type:this.fileData.c_type,
                        c_type:1,
                        vc_gsaccount:this.fileData.vc_bank_account,

                    };
                    let res = await API.processData(param);
                    if (res.code == 1||res.code == 0) {
                        this.zkpercentageTxt=res.message
                        // this.hppercentageTxt=res.hp.message
                        // this.hxpercentageTxt=res.hx.message
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        // this.$message.error(res.message);
                    }


            },
            async uploadFile(value) {
                this.back='save'
                let that = this;
                let $files = value.target.files[0];
                this.files=$files
                let fileName = $files.name
                let typeList=['xls'];
                let type=fileName.split('.').pop().toLowerCase();
                if(!typeList.includes(type)){
                    that.$message.error(that.$t('tips_please_upload_the_file_in_the_correct_format'));
                    return;
                };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var param = {
                        excelName:that.fileName,
                        i_bzid:that.fileData.i_bzid,
                        i_gsid:that.fileData.i_gsid,
                    };
                    let res = await API.validName(param);
                    if (res.code == 1) {
                        this.fileData=res.data
                        this.fileData.fileName=that.fileName
                        this.fileData.files=that.files
                        if(this.fileData.i_bzid==1)this.fileData.f_rate=1
                        // console.log(this.fileData)
                        this.$forceUpdate()
                        this.$refs.uploadclear.value=null
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$refs.uploadclear.value=null
                        this.$message.error(res.message);
                    } else {
                        this.$refs.uploadclear.value=null

                        this.$message.error(res.message);

                    }

                }
            },
            async importFile(){
                this.back='save'

                this.timestamp = (new Date()).valueOf();
                this.sse_funProgress('sc')
                this.sc=true
                this.scShow=true
                // console.log(this.timestamp,'this.timestamp')
                let file={
                    file:this.fileData.files,
                    excelName:this.fileData.fileName,
                    i_pid:this.fileData.i_pid,
                    i_bzid:this.fileData.i_bzid,
                    i_gsid:this.fileData.i_gsid,
                    vc_gsname:this.fileData.vc_gsname,
                    vc_gsaccount:this.fileData.vc_bank_account,
                    f_rate:this.fileData.f_rate,
                    sessionId:this.timestamp,
                }
                let param=file;
                // let FD = new FormData();
                // for (let key in param) {
                //     FD.append(key, param[key])
                // }
                let res=await API.importFile(param);
                if ( res.code == 1 ){
                    this.errorMessage=''
                    this.importFileData=res
                }else if (res.code == -2) {
                    this.errorMessage=''

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else if ( res.code == 0 ){
                    this.activeId=0
                    this.sc=false
                    this.scShow=false
                    this.errorMessage=res.message
                    this.$message.error(res.message);

                }else{
                    this.errorMessage=''

                    this.$message.error(res.message);
                }
            },

            //关闭SSE接口
            async closeSSEProgress(){
                this.sourceProgress.close();
                let param={
                    userId:this.timestamp+'',
                };
                let res=await API.closeSSE(param);
                if(res.code==1){
                }else if (res.code == -2) {
                    this.$router.push('/login');
                }
                else{
                }
            },
            //关闭SSE接口
            async closeSSEError(){
                this.sourceError.close();
                let param={
                    userId:this.timestamp+'',
                };
                let res=await API.closeSSE(param);
                if(res.code==1){
                }else if (res.code == -2) {
                    this.$router.push('/login');
                }
                else{
                }
            },
            sse_funProgress(type){
                let that=this;
                let token=sessionStorage.getItem("token")
                let i_uid=sessionStorage.getItem("userid")
                let app=this.baseApp
                let version=this.baseVersion;
                var MESSAGR_URL=sse_url+"/"+"connect"+"/"+this.timestamp+'/'+token+'/'+i_uid+'/'+app+'?version='+version;
                this.sourceProgress= new EventSource(MESSAGR_URL);
                this.sourceProgress.addEventListener('open',function (e) {
                })
                this.sourceProgress.addEventListener('error',function (e) {
                })
                this.sourceProgress.addEventListener('message',function (e) {
                    // excelImportProgress
                    //excelImportError
                    let data=JSON.parse(e.data)
                    // console.log(data.order)

                    if(data.order=='excelImportProgress'){
                        if(type=='sc'){
                            that.scpercentage=data.message
                            if(that.scpercentage==100)
                            {
                                that.closeSSEProgress()
                                that.activeId=1
                                that.disabled=false

                            }
                        }else{

                        }
                    }else if(data.order=='excelImportError'){
                        if(type=='sc'){
                            that.scList.push(data.message)

                        }else{

                        }

                    }else if(data.order=='processDataExcept'){
                        that.zkList.push(data.message)
                        // if(type=='clhp'){
                        //     that.hpList.push(data.message)
                        // }
                    }else if(data.order=='processDataProgress'){
                        that.zkpercentage=data.message
                        if(that.zkpercentage==100){
                            that.closeSSEProgress()
                            that.activeId=3
                            that.disabled=false

                        }
                        // if(type=='clhp'){
                        //     that.hppercentage=data.message
                        //     if(that.hppercentage==100){
                        //         that.closeSSEProgress()
                        //         that.activeId=2
                        //         that.disabled=false
                        //     }
                        // }
                    }
                    that.$forceUpdate()

                })
            },
            sse_funError(){
                let that=this;
                let token=sessionStorage.getItem("token")
                let i_uid=sessionStorage.getItem("userid")
                let app=this.baseApp
                let version=this.baseVersion;
                var MESSAGR_URL=sse_url+"/"+"connect"+"/"+this.timestamp+'/'+token+'/'+i_uid+'/'+app+'?version='+version
                this.sourceError= new EventSource(MESSAGR_URL);
                this.sourceError.addEventListener('open',function (e) {
                })
                this.sourceError.addEventListener('error',function (e) {
                })
                this.sourceError.addEventListener('message',function (e) {
                    var message=e.data;
                    if(message){
                        this.scList.push(e.data)

                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .o-f-y-s{
        overflow-y: scroll;
    }
    .yuan{
        display: inline-block;
        border-radius: 9px;
        padding: 3px 2px 2px;
        font-size: 10px;
        text-align: center;
        line-height: 1;
        min-width: 11px;
    }
    .ghwyuancolor{
        border: 1px solid var(--lightghw);

    }
    .havayyuancolor{
        border: 1px solid var(--lighthavay);

    }
    .txtBox{
        padding:4px 0;
    }
    .stepsBox{
        padding: 10px 70px;
    }
    .formBox{
        /*padding: 10px;*/
        line-height: 1.5;
        /deep/.el-button{
            padding: 0;
        }
    }
    .p15-10{
        padding: 10px 10px 0;
    }
    .p10{
        padding:0 10px;

    }
    .scListBox{
        margin: 8px 0;
    }
    .labelBox{
        width: 70px;
        margin-right: 10px;
        display: inline-block;
    }
    .keyBox{
        width: calc(100% - 70px);
        display: inline-block;
        text-align: left;
    }
    .colortheme{
        color: var(--light);
        text-decoration: none
    }
    .filecss{
        color: var(--light);
        font-size: 14px;
    }
    .flex{
        display: flex;
    }
    .a-i-c{
        align-items: center;

    }
    .a-i-b{
        align-items: baseline;

    }
    .jcsb{
        justify-content: space-between;
    }
    .inputH {
        /deep/ {
            .el-input__inner {
                height: inherit;
                line-height: inherit;
                text-align: left;

            }
            .el-input-number{
                height: inherit;
                line-height: inherit;
                text-align: left;
            }
        }
    }
    .el-input-number{
        height: inherit;
        line-height: inherit;
    }
    .upload{

        .el-input{
            position: absolute;
            top: 0;
            /*width: 90%;*/
            opacity:0 ;
        }
        .el-button{
            position: absolute;
            top: 0;
        }

    }
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;

    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
    }
    .bor{
        border: 1px solid #b2b2b2;
        padding-left:  10px;
        padding-right:  10px;

    }
    .p-8-10{
        padding: 8px 10px;

    }
    .center{
        text-align: center;
    }
    /deep/{
        .el-step__icon-inner{line-height: normal}
        .el-step__head.is-success{
            /*.el-step__icon.is-icon{*/
            /*    border-radius: 50%;*/
            /*    border: 2px solid;*/
            /*    border-color:inherit ;*/
            /*    width: 24px;*/
            /*}*/
        }
        .el-step__description{
            padding-top: 8px;
        }

    }


</style>